module.exports = __webpack_public_path__ + "images/19743-EXT1-CAM04-c6094af61ceb93203c1bf5a2c849c975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_3/19743-EXT1-CAM04.jpg
// module id = 781
// module chunks = 0